export const API_RESPONSE = {
  SUCCESS: {
    SUPABASE: {
      INITIALIZE: {
        CODE: 200,
        MESSAGE: "Supabase initialized successfully.",
      },
      CREDENTIALS:{
        CODE: 200,
        MESSAGE: "Supabase credentials verified successfully.",
      },
    },
    MY_SQL: {
      INITIALIZE: {
        CODE: 200,
        MESSAGE: "MySQL connection established successfully.",
      },
      CREDENTIALS:{
        CODE: 200,
        MESSAGE: "MySQL credentials validated successfully.",
      },
    },
    AUTH: {
      SIGN_IN: {
        CODE: 200,
        MESSAGE: "User signed in successfully.",
      },
      SIGN_UP: {
        CODE: 200,
        MESSAGE: "User registered successfully.",
      },
      SIGN_OUT: {
        CODE: 200,
        MESSAGE: "User sign-out successfully.",
      },
      RESET_PASSWORD: {
        CODE: 200,
        MESSAGE: "Password reset request processed successfully.",
      },
      RESEND_CONFIRMATION_LINK: {
        CODE: 200,
        MESSAGE: "Confirmation link sent successfully.",
      },
    },
    ATTACHMENT: {
      CREATE: { CODE: 200, MESSAGE: "Attachment created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "Attachment updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "Attachment retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All attachments retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "Attachment deleted successfully." },
    },
    CLIENTS: {
      CREATE: { CODE: 200, MESSAGE: "Client created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "Client updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "Client retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All clients retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "Client deleted successfully." },
    },
    COMPANY: {
      CREATE: { CODE: 200, MESSAGE: "Company created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "Company updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "Company retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All companies retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "Company deleted successfully." },
    },
    FINANCIALS: {
      CREATE: { CODE: 200, MESSAGE: "Financial record created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "Financial record updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "Financial record retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All financial records retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "Financial record deleted successfully." },
    },
    LEADS: {
      CREATE: { CODE: 200, MESSAGE: "Lead created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "Lead updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "Lead retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All leads retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "Lead deleted successfully." },
    },
    MONITORINGS: {
      CREATE: { CODE: 200, MESSAGE: "Monitoring created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "Monitoring updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "Monitoring retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All monitorings retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "Monitoring deleted successfully." },
    },
    PROPOSALS: {
      CREATE: { CODE: 200, MESSAGE: "Proposal created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "Proposal updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "Proposal retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All proposals retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "Proposal deleted successfully." },
    },
    PROPOSAL_ITEMS: {
      CREATE: { CODE: 200, MESSAGE: "Proposal item created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "Proposal item updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "Proposal item retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All proposal items retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "Proposal item deleted successfully." },
    },
    PROPOSAL_ATTACHMENT: {
      CREATE: { CODE: 200, MESSAGE: "Proposal attachment created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "Proposal attachment updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "Proposal attachment retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All proposal attachments retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "Proposal attachment deleted successfully." },
    },
    PROPOSAL_PRICING_SUMMARY: {
      CREATE: { CODE: 200, MESSAGE: "Proposal pricing summary created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "Proposal pricing summary updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "Proposal pricing summary retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All proposal pricing summaries retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "Proposal pricing summary deleted successfully." },
    },
    SALES: {
      CREATE: { CODE: 200, MESSAGE: "Sale created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "Sale updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "Sale retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All sales retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "Sale deleted successfully." },
    },
    SALES_ATTACHMENT: {
      CREATE: { CODE: 200, MESSAGE: "Sales attachment created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "Sales attachment updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "Sales attachment retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All sales attachments retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "Sales attachment deleted successfully." },
    },
    USERS: {
      CREATE: { CODE: 200, MESSAGE: "User created successfully." },
      UPDATE: { CODE: 200, MESSAGE: "User updated successfully." },
      GET_BY_ID: { CODE: 200, MESSAGE: "User retrieved successfully." },
      GET_ALL: { CODE: 200, MESSAGE: "All users retrieved successfully." },
      DELETE: { CODE: 200, MESSAGE: "User deleted successfully." },
    },
    SYSTEM:{
      NOT_FOUND: { CODE: 404, MESSAGE: "Requested resource not found." },
      INTERNAL_SERVER_ERROR: { CODE: 500, MESSAGE: "Internal server error occurred." },
    }
  },
  ERROR: {
    SUPABASE: {
      INITIALIZE: {
        CODE: 500,
        MESSAGE: "Failed to initialize Supabase.",
      },
      CREDENTIALS:{
        CODE: 401,
        MESSAGE: "Invalid Supabase credentials.",
      },
    },
    MY_SQL: {
      INITIALIZE: {
        CODE: 500,
        MESSAGE: "Failed to connect to MySQL.",
      },
      CREDENTIALS:{
        CODE: 401,
        MESSAGE: "Invalid MySQL credentials.",
      },
    },
    AUTH: {
      SIGN_IN: {
        CODE: 401,
        MESSAGE: "Sign-in failed. Invalid credentials.",
      },
      SIGN_UP: {
        CODE: 400,
        MESSAGE: "Sign-up failed. Invalid data provided.",
      },
      SIGN_OUT: {
        CODE: 400,
        MESSAGE: "Sign-out failed.",
      },
      RESET_PASSWORD: {
        CODE: 400,
        MESSAGE: "Password reset failed.",
      },
      RESEND_CONFIRMATION_LINK: {
        CODE: 400,
        MESSAGE: "Failed to resend confirmation link.",
      },
      USER_EXISTS: {
        CODE: 400,
        MESSAGE: "User already exist.",
      },
      USER_NOT_FOUND: {
        CODE: 404,
        MESSAGE: "User not found.",
      },
    },
    ATTACHMENT: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create attachment." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update attachment." },
      GET_BY_ID: { CODE: 404, MESSAGE: "Attachment not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve attachments." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete attachment." },
    },
    CLIENTS: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create client." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update client." },
      GET_BY_ID: { CODE: 404, MESSAGE: "Client not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve clients." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete client." },
    },
    COMPANY: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create company." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update company." },
      GET_BY_ID: { CODE: 404, MESSAGE: "Company not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve companies." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete company." },
    },
    FINANCIALS: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create financial record." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update financial record." },
      GET_BY_ID: { CODE: 404, MESSAGE: "Financial record not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve financial records." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete financial record." },
    },
    LEADS: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create lead." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update lead." },
      GET_BY_ID: { CODE: 404, MESSAGE: "Lead not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve leads." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete lead." },
    },
    MONITORINGS: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create monitoring." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update monitoring." },
      GET_BY_ID: { CODE: 404, MESSAGE: "Monitoring not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve monitorings." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete monitoring." },
    },
    PROPOSALS: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create proposal." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update proposal." },
      GET_BY_ID: { CODE: 404, MESSAGE: "Proposal not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve proposals." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete proposal." },
    },
    PROPOSAL_ITEMS: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create proposal item." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update proposal item." },
      GET_BY_ID: { CODE: 404, MESSAGE: "Proposal item not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve proposal items." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete proposal item." },
    },
    PROPOSAL_ATTACHMENT: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create proposal attachment." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update proposal attachment." },
      GET_BY_ID: { CODE: 404, MESSAGE: "Proposal attachment not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve proposal attachments." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete proposal attachment." },
    },
    PROPOSAL_PRICING_SUMMARY: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create proposal pricing summary." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update proposal pricing summary." },
      GET_BY_ID: { CODE: 404, MESSAGE: "Proposal pricing summary not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve proposal pricing summaries." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete proposal pricing summary." },
    },
    SALES: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create sale." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update sale." },
      GET_BY_ID: { CODE: 404, MESSAGE: "Sale not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve sales." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete sale." },
    },
    SALES_ATTACHMENT: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create sales attachment." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update sales attachment." },
      GET_BY_ID: { CODE: 404, MESSAGE: "Sales attachment not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve sales attachments." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete sales attachment." },
    },
    USERS: {
      CREATE: { CODE: 400, MESSAGE: "Failed to create user." },
      UPDATE: { CODE: 400, MESSAGE: "Failed to update user." },
      GET_BY_ID: { CODE: 404, MESSAGE: "User not found." },
      GET_ALL: { CODE: 500, MESSAGE: "Failed to retrieve users." },
      DELETE: { CODE: 400, MESSAGE: "Failed to delete user." },
    },
    SYSTEM:{
      NOT_FOUND: { CODE: 404, MESSAGE: "Requested system resource not found." },
      INTERNAL_SERVER_ERROR: { CODE: 500, MESSAGE: "Internal system error occurred." },
    }
  }
}